// LogoutModal.js
import React from "react";
import styled, { keyframes } from "styled-components";
import { FaTimes, FaPowerOff } from "react-icons/fa"; // Added power icon
import { gradients } from "../theme/theme";

/* --- Animations --- */
const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.95) }
  to { opacity: 1; transform: scale(1) }
`;

const slideUp = keyframes`
  from { transform: translateY(40px); opacity: 0 }
  to { transform: translateY(0); opacity: 1 }
`;

/* --- Overlay --- */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  animation: ${fadeIn} 0.25s ease;
`;

/* --- Modal Box --- */
const ModalBox = styled.div`
  background: ${gradients.heroBackground};
  border-radius: 18px;
  padding: 2rem;
  width: 100%;
  max-width: 420px;
  color: #fff;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: ${slideUp} 0.3s ease;
  position: relative;
  text-align: center;
`;

/* --- Close Button --- */
const CloseBtn = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  padding: 8px;
  border-radius: 50%;
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.25s;

  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }
`;

/* --- Title Section --- */
const Title = styled.h2`
  margin: 0.5rem 0 1rem;
  font-size: 1.8rem;
  background: linear-gradient(90deg, #ff7a18, #ff0066);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const Message = styled.p`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 1.5rem;
`;

/* --- Buttons --- */
const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const ActionBtn = styled.button`
  flex: 1;
  padding: 0.8rem;
  border-radius: 12px;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.25s, box-shadow 0.25s;

  ${({ variant }) =>
    variant === "cancel"
      ? `
        background: rgba(255,255,255,0.1);
        color: #fff;
        &:hover {
          background: rgba(255,255,255,0.2);
        }
      `
      : `
        background: linear-gradient(90deg, #ff7a18, #ff0066);
        color: #fff;
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(255, 0, 102, 0.4);
        }
      `}
`;

export default function LogoutModal({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <Overlay>
      <ModalBox>
        {/* <CloseBtn onClick={onClose}>
          <FaTimes />
        </CloseBtn> */}

        <Title>
          <FaPowerOff /> Logout
        </Title>

        <Message>
          Are you sure you want to log out? You’ll need to sign in again to
          access your account.
        </Message>

        <ButtonGroup>
          <ActionBtn variant="cancel" onClick={onClose}>
            Cancel
          </ActionBtn>
          <ActionBtn onClick={onConfirm}>Yes, Logout</ActionBtn>
        </ButtonGroup>
      </ModalBox>
    </Overlay>
  );
}
